// extracted by mini-css-extract-plugin
export default {"botaoPrincipal":"BotaoPrincipal_botaoPrincipal__dH+e1","lg":"BotaoPrincipal_lg__gKDFc"};